import { SearchUserEnriched } from 'lib-search-types';

/**
 * Check whether an agent is currently in a phone or callback conversation.
 */
export function isAgentOnThePhone(member: SearchUserEnriched): boolean {
  return (member.active_phone_calls?.length ?? 0) > 0;
}
